<template>
  <v-card>
    <v-card-title class="headline py-2">
      Объединить объекты
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')">
        <v-icon>close</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
      <v-data-table class="obj-props-table" :headers="headers" :items="data" hide-actions no-data-text="Данные отсутствуют">
        <template slot="items" slot-scope="{item, index}">
          <td><v-checkbox :input-value="result.id===item.id" color="primary" hide-details @click="result=item"></v-checkbox></td>
          <td>{{item.name}}</td>
          <td>{{getProperties(item.properties)}}</td>
        </template>
      </v-data-table>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled || !result.id">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: "MergeObjectsForm",
    
    props: {
      data: {
        type: Array,
        required: true,
        default: () => []
      },
    },
    
    data() {
      return {
        status : {
          btnDisabled: false,
          text: '',
          className : 'success--text darken-1'
        },
        headers: [
          { text: 'Результат', align: 'left', sortable: false, width: 40 },
          { text: 'Объект', align: 'left', sortable: false },
          { text: 'Признаки', align: 'left', sortable: false },
        ],
        result: {}
      }
    },
    
    methods: {
      submit() {
        if(this.result.id){
          this.status = { btnDisabled : true, text : 'Сохранение', className : 'secondary--text lighten-1' }
          let removeObjects = this.data.filter(item => item.id!==this.result.id)
          this.$store.dispatch('analytics/constructor/mergeObjects', {data: this.data, result: this.result, join_type: 1} ).then( response => {
            this.status = { btnDisabled : false, text : 'Сохранено', className : 'success--text darken-1' }
            this.$emit('save', {type: 'mergeObjects', data: removeObjects} )
          }).catch( error => {
            this.status = { btnDisabled : false, text : 'Ошибка', className : 'error--text darken-1' }
          })
        }
      },
  
      getProperties(properties){
        let name = '';
        properties.map(item => {
          name+=item.identified+' -> '
        })
        return name.substring(0, name.length-4)
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/MergeObjectsForm.vue